/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityServiceAreaStatus } from './FacilityServiceAreaStatus';
import {
    FacilityServiceAreaStatusFromJSON,
    FacilityServiceAreaStatusFromJSONTyped,
    FacilityServiceAreaStatusToJSON,
    FacilityServiceAreaStatusToJSONTyped,
} from './FacilityServiceAreaStatus';

/**
 * 
 * @export
 * @interface CreateFacilityServiceAreaRequest
 */
export interface CreateFacilityServiceAreaRequest {
    /**
     * A 5-digit US ZIP code (e.g. "10001").
     */
    zip: string;
    /**
     * 
     */
    status: FacilityServiceAreaStatus;
    /**
     * 
     */
    city?: string;
    /**
     * 
     */
    state_id?: string;
    /**
     * 
     */
    notes?: string;
}



/**
 * Check if a given object implements the CreateFacilityServiceAreaRequest interface.
 */
export function instanceOfCreateFacilityServiceAreaRequest(value: object): value is CreateFacilityServiceAreaRequest {
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function CreateFacilityServiceAreaRequestFromJSON(json: any): CreateFacilityServiceAreaRequest {
    return CreateFacilityServiceAreaRequestFromJSONTyped(json, false);
}

export function CreateFacilityServiceAreaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityServiceAreaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'zip': json['zip'],
        'status': FacilityServiceAreaStatusFromJSON(json['status']),
        'city': json['city'] == null ? undefined : json['city'],
        'state_id': json['state_id'] == null ? undefined : json['state_id'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateFacilityServiceAreaRequestToJSON(json: any): CreateFacilityServiceAreaRequest {
    return CreateFacilityServiceAreaRequestToJSONTyped(json, false);
}

export function CreateFacilityServiceAreaRequestToJSONTyped(value?: CreateFacilityServiceAreaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'zip': value['zip'],
        'status': FacilityServiceAreaStatusToJSON(value['status']),
        'city': value['city'],
        'state_id': value['state_id'],
        'notes': value['notes'],
    };
}

